/* LINFA — Living Collection: card reveals + hero video parallax */
(function () {
  const root = document.querySelector(".linfa-living-collection");
  if (!root) return;

  // Reveal cards on intersect (staggered)
  const cards = root.querySelectorAll(".lc-card");
  if ("IntersectionObserver" in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry, idx) => {
          if (entry.isIntersecting) {
            setTimeout(() => entry.target.classList.add("is-in"), idx * 90);
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.14, rootMargin: "0px 0px -60px 0px" }
    );
    cards.forEach((c) => io.observe(c));
  } else {
    cards.forEach((c) => c.classList.add("is-in"));
  }

  // Slight parallax on hero video during scroll
  const video = root.querySelector(".lc-hero-video");
  if (video && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    let raf;
    window.addEventListener(
      "scroll",
      () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const y = Math.min(window.scrollY, 800);
          video.style.transform = `scale(1.05) translate3d(0, ${y * 0.12}px, 0)`;
        });
      },
      { passive: true }
    );
  }
})();
